import React from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

const TabList = ({ children }) => {
  return (
    <Tabs transition={false}>
      {React.Children.map(children, (tab) => (
        <Tab eventKey={tab.props.title} title={tab.props.title}>
          {tab}
        </Tab>
      ))}
    </Tabs>
  );
};

export default TabList;
